import { render, staticRenderFns } from "./loginModal.vue?vue&type=template&id=f1c006b8&scoped=true"
import script from "./loginModal.vue?vue&type=script&lang=js"
export * from "./loginModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c006b8",
  null
  
)

export default component.exports